/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

const newsletterTagline = [
  {
    name: "money-order",
    tagLine: "Stay informed about the market trends and learn curated insights about industry with our comprehensive, weekly newsletter."
  },
  {
    name: "big-picture",
    tagLine: "Dive deep into macroeconomic changes and emerging trends with our monthly newsletter."
  },
  {
    name: "partner-blog",
    tagLine: "Step-by-step guidance on starting and establishing your wealth management business."
  },
  {
    name: "partner-news",
    tagLine: "Stay informed with the latest news around the market and get regulatory updates."
  }
];

export default newsletterTagline;
